import { render, staticRenderFns } from "./estoque-servicos.vue?vue&type=template&id=05279e90&scoped=true&"
import script from "./estoque-servicos.vue?vue&type=script&lang=js&"
export * from "./estoque-servicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05279e90",
  null
  
)

export default component.exports